import { render, staticRenderFns } from "./MedicationUnitTable.vue?vue&type=template&id=675b1c4a&scoped=true"
import script from "./MedicationUnitTable.vue?vue&type=script&lang=js"
export * from "./MedicationUnitTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "675b1c4a",
  null
  
)

export default component.exports